<template>
  <div class="related mb-7">
    <div class="related__head">
      <h2 class="related__title">{{ title }}</h2><!-- /.related__title -->
    </div><!-- /.related__head -->

    <div class="related__body">
      <b-row>
        <b-col xs="12" lg="6" xl="4" v-for="(item,index) in similarCollections.slice(0,3)" :key="index">
          <b-card no-body class="card-article">
            <!-- Card image -->
            <div :class="'card-img-top' + itemImageClass(item)">
              <!-- <a :href="item.id" @click="loadCollectionPage($event)"> -->
              <a href="#!">
                <img :src="item.img" :alt="item.img_alt" v-if="item.img">
              </a>
            </div>
            <!-- Card body -->
            <b-card-body>
              <div class="card-badge">
                <p>
                  <strong>{{ countRecipes(item.recipes) }}</strong>
                  {{ badgeText }}
                </p>
              </div><!-- /.card-badge -->
              <b-card-title class="h2 mb-0">
                <!-- <a :href="item.id" @click="loadCollectionPage($event)">{{ item.title }}</a> -->
                <a href="#!">{{ item.title }}</a>
              </b-card-title>
              <small class="text-muted">{{ authorBy }} {{ item.author }}, {{ item.date_created }}</small>
              <b-card-text class="mt-4 js-truncate-summary" v-html="item.text"></b-card-text>
              <div class="d-flex justify-content-between align-items-center">
                <a href="#!" class="btn btn-link px-0" >{{ viewButton }}</a>
                <!-- <a :href="item.id" class="btn btn-link px-0" @click="loadCollectionPage($event)">{{ viewButton }}</a> -->
                <div class="icon-actions">
                  <a href="#" class="like active" @click="handleLike($event, index, item)">
                    <i class="ni ni-like-2"></i>
                    <span class="text-muted">{{ item.likes }}</span>
                  </a>
                  <a href="#">
                    <i class="ni ni-chat-round"></i>
                    <span class="text-muted">{{ item.comments }}</span>
                  </a>
                  <a href="#">
                    <i class="ni ni-curved-next"></i>
                    <span class="text-muted">{{ item.shares }}</span>
                  </a>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div><!-- /.related__body -->
  </div><!-- /.related -->
</template>
<script>
  import { ellipsis } from 'ellipsed';

  export default {
    name: 'similar-collections',
    props: ['recipeId'],
    components: {
    },
    data() {
      return {
        data: null,
        similarCollections: []
      }
    },
    computed: {
      apiKey() {
        return this.data && this.data.api_key;
      },
      title() {
        return this.data && this.data.collections.similar_title;
      },
      collections() {
        return this.data && this.data.collections.items;
      },
      badgeText() {
        return this.data && this.data.collections.badge_text;
      },
      authorBy() {
        return this.data && this.data.collections.author_by;
      },
      viewButton() {
        return this.data && this.data.collections.view_button;
      }
    },
    methods: {
      onCreated() {
        // get collections
        // this.collections.filter((collection) => {
        //   collection.recipes.filter((recipe) => {
        //     if (recipe.id == this.recipeId) {
        //       this.similarCollections.push(collection);
        //     }
        //   })
        // });

        setTimeout(function(){
          ellipsis('.js-truncate-summary', 2, {
            responsive: true
          });
        }, 200);
      },
      countRecipes(recipes) {
        return recipes.length;
      },
      itemImageClass(element) {
        return element.img_class ? ' card-img-top--' + element.img_class : '';
      },
      loadRecipePage(event) {
        event.preventDefault();

        let route = 'recipe';
        const button = event.target.closest('a');

        if (button) {
          this.$router.push({
            path: route,
            query: {
              id: button.getAttribute('href')
            }
          }).catch(() => {});

          scroll({
            top: 0,
            behavior: "smooth"
          });
        }
      },
      handleLike(event, index, item) {
        event.preventDefault();

        const likeButton = event.target.closest('.like');

        if (likeButton) {
          likeButton.classList.contains('active') ? item.likes-- : item.likes++;
          likeButton.classList.toggle('active');
        }
      },
      loadCollectionPage(event) {
        event.preventDefault();

        let route = 'collection';
        const button = event.target.closest('a');

        if (button) {
          this.$router.push({
            path: route,
            query: {
              id: button.getAttribute('href')
            }
          }).catch(() => {});
        }
      }
    },
    created(){
      this.onCreated();
    },
    watch: {
      $route(to, from) {
        this.onCreated();
      }
    }
  }
</script>
<style></style>
